import { createRouter, createWebHistory } from 'vue-router';
import { signInByWechat } from '@/request/api';
import HomeView from '../views/HomeView.vue';
const routes = [{
  path: '/',
  name: 'home',
  component: HomeView
}, {
  path: '/play',
  name: 'play',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import( /* webpackChunkName: "about" */'../views/PlayView.vue')
}, {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: () => import( /* webpackChunkName: "about" */'../views/notFound.vue'),
  meta: {
    template: 'oneScreenTemp',
    keepAlive: true,
    title: 'NotFound',
    isAuth: false
  }
}];
const router = createRouter({
  history: createWebHistory(),
  routes
});
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.path == '/login' || to.path == '/') {
    next();
  } else {
    if (to.path == '/play' && to.query.code) {
      let params = {
        code: to.query.code,
        source: 'subo'
      };
      signInByWechat(params).then(res => {
        if (res.success) {
          localStorage.setItem('token', res.result.token);
          localStorage.setItem('refreshToken', res.result.refreshToken);
          localStorage.setItem('userId', res.result.userId);
          localStorage.setItem('userType', res.result.userType);
          localStorage.setItem('wdpId', res.result.wdpId);
          next();
        } else {
          console.log('授权登陆失败，请重新登录');
          ElMessage.error('授权登陆失败，请重新登录');
          next('/');
        }
      }).catch(e => {
        console.log('授权登陆失败，请重新登录', e);
        ElMessage.error('授权登陆失败，请重新登录');
        next('/');
      });
    } else if (!!token) {
      next();
    } else {
      next('/');
    }
  }
});
export default router;